/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleRequest
 */
export interface RoleRequest {
    /**
     * 
     * @type {string}
     * @memberof RoleRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RoleRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the RoleRequest interface.
 */
export function instanceOfRoleRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function RoleRequestFromJSON(json: any): RoleRequest {
    return RoleRequestFromJSONTyped(json, false);
}

export function RoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function RoleRequestToJSON(value?: RoleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'notes': value.notes,
    };
}

